import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingCartIcon, DownloadIcon, CalendarCheckIcon } from 'lucide-react';
import { steps } from '../data/content';
const icons = {
  cart: ShoppingCartIcon,
  download: DownloadIcon,
  calendar: CalendarCheckIcon
};
export function HowItWorks() {
  return <section className="w-full bg-blush px-5 py-12 sm:py-20" data-id="element-130" data-mp="3tzbkbyianpvn">
      <div className="mx-auto max-w-5xl" data-id="element-131" data-mp="3u1wo4t25kfw1">
        <div className="mx-auto max-w-2xl text-center" data-id="element-132" data-mp="lk0azbc5yd1a">
          <h2 className="font-display text-2xl font-bold leading-tight text-foreground sm:text-4xl" data-id="element-133" data-mp="lmmgz6jeokhe">
            ¿Cómo <span className="text-pink" data-id="element-134" data-mp="cry9rau9sspy">funciona</span>?
          </h2>
          <p className="mt-3 text-sm text-muted sm:text-base" data-id="element-135" data-mp="crpytohpjxhe">
            Simple, inmediato y a tu ritmo.
          </p>
        </div>

        <div className="mt-12 flex flex-col gap-8 md:flex-row md:gap-6" data-id="element-136" data-mp="14je79zxd7zuy">
          {steps.map((step, i) => {
          const Icon = icons[step.icon];
          return <React.Fragment key={step.number} data-id="element-137" data-mp="19b5mjeb2mj5s" data-mpi={i}>
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              amount: 0.3
            }} transition={{
              duration: 0.45,
              delay: i * 0.1
            }} className="flex flex-1 flex-col items-center text-center" data-id="element-138" data-mp="2rl4qur889iym">
                <span className="flex h-16 w-16 items-center justify-center rounded-full border border-line bg-surface text-primary" data-id="element-139" data-mp="3abmggmxrjyfr">
                  <Icon className="h-7 w-7" aria-hidden="true" data-id="element-140" data-mp="369sm0we5vqo1" />
                </span>
                <span className="mt-4 font-display text-2xl font-bold text-primary" data-id="element-141" data-mp="3k9adjjiudi13">
                  {step.number}
                </span>
                <h3 className="mt-2 text-lg font-bold text-foreground" data-id="element-142" data-mp="3f95sdg6znz4j">{step.title}</h3>
                <p className="mt-3 max-w-xs text-sm leading-relaxed text-muted" data-id="element-143" data-mp="1pwkhow8wxyr2">
                  {step.description}
                </p>
              </motion.div>
              {i < steps.length - 1 && <div className="mx-auto h-8 w-px bg-primary/30 md:hidden" aria-hidden="true" data-id="element-144" data-mp="3l11qt0d874to" />}
            </React.Fragment>;
        })}
        </div>
      </div>
    </section>;
}